export default "__VITE_ASSET__Buut9SzX__"